"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDeepEqual = void 0;
const isDeepEqual = (x, y) => !!(x && y && typeof x === 'object' && typeof y === 'object' ? Object.keys(x).length === Object.keys(y).length && Object.keys(x).reduce((isEqual, key) => isEqual && isDeepEqual(x[key], y[key]), true) : x === y);
exports.isDeepEqual = isDeepEqual;